'use client';

var translations = {
    'View analysis before applying': 'Xem phân tích trước khi ứng tuyển',
    'Continue applying': 'Tiếp tục ứng tuyển',
    'Maximize your competitive advantage before applying': 'Tối ưu lợi thế cạnh tranh trước khi ứng tuyển',
    'Maximize your competitive advantage with VietnamWorks AI before applying': 'Tối ưu lợi thế cạnh tranh trước khi ứng tuyển cùng VietnamWorks AI',
    "Assess matching rate from employer's viewpoint": 'Đánh giá mức độ phù hợp với góc nhìn của nhà tuyển dụng',
    'Suggest to improve the matching': 'Gợi ý cách cải thiện mức độ phù hợp',
    'Analyze the profiles of applicants': 'Phân tích hồ sơ của các ứng viên đã nộp đơn',
    'Check salary reference and hiring demand': 'Tham khảo mức lương và nhu cầu tuyển dụng',
    'Explore the': 'Khám phá ngay',
    'Competitive analysis report': 'Báo cáo phân tích mức độ cạnh tranh',
    'now to get closer to your dream job!': 'để tiến gần hơn đến công việc mơ ước!',
    'View analysis to maximize now': 'Xem phân tích để tối ưu ngay',
    'Do you want to maximize competitive advantage before applying?': 'Bạn có muốn tối ưu lợi thế cạnh tranh trước khi ứng tuyển?'
};

export { translations };
//# sourceMappingURL=translations.js.map
